import { render, staticRenderFns } from "./extra-listing.vue?vue&type=template&id=b50d17d4"
import script from "./extra-listing.vue?vue&type=script&lang=js"
export * from "./extra-listing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports